import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Title } from '../../containers/DefaultStyles/Shared';
import { isLongText } from '../../components/Shared/commonFunctions';

const OverlayTitle = props => {
    return (
        <Title
            isShortText={!isLongText(props.text, 28)}
            isLongText={isLongText(props.text, 60)}
            isExtraLongText={isLongText(props.text, 95)}
            scaleFactor={0.75}
            dangerouslySetInnerHTML={{ __html: props.text }}
        />
    );
};

OverlayTitle.propTypes = {
    text: PropTypes.string.isRequired
};

export default connect(
    state => {
        const currCard = state.widget.cards[state.widget.activeAction.order - 1];
        return {
            text: (currCard.heading || state.widget.activeAction.name || '').replace(
                /@articleUrl/g,
                state.widget.articleUrl
            )
        };
    },
    {}
)(OverlayTitle);
